'use strict'

/**
 * Project easytitle24 app
 * Created by hielo on 2018-06-09
 */

import ProjectAudit from './project-audit.vue'

const routes = [
	{
		path: '/project-audit/:id/:printable',
		name: 'project.audit',
		component: ProjectAudit,
		props: true,
		meta: { authRequired: true }
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/app/project-audit/index.js